import React, { useState } from "react";
import PortafolioServicesList from "./PortafolioServicesList";
import LoadSimple from "../LoadSimple";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const TablePortafolioServices = ({
  pageActual,
  limitList,startLimit,
  devices,
  dataList,
  cisSelected,
  setServiceSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  dataService,
  setDataService,
  sla,
  setSla,
  dataObject,
  setDataObject,
  languaje,
  handleShowPopup,
  mode
}) => {
  return (
    <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
        <div className="compact-head-table-portafolio">
        <div className="field-head-table-portafolio field-larger">ID</div>
        <div className="field-head-table-portafolio field-larger" style={{width:'25%'}}>{capitalizeFirstLetter(lang[languaje]['servicio'])}</div>
        <div className="field-head-table-portafolio field-larger" style={{width:'20%'}}>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</div>
        <div className="field-head-table-portafolio field-larger">SLA</div>
        <div className="field-head-table-portafolio field-larger">{capitalizeFirstLetter(lang[languaje]['severidad'])}</div>
        <div className="field-head-table-portafolio field-larger">{capitalizeFirstLetter(lang[languaje]['acciones'])}</div>  
        </div>
        
      </div>
      <div className="body-table-portafolio">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <PortafolioServicesList
          setDataService={setDataService}
      dataService={dataService}
            pageActual={pageActual}
             limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setServiceSelected={setServiceSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            sla={sla}
                      setSla={setSla}
                      dataObject={dataObject}
                      setDataObject={setDataObject}
                      languaje={languaje}
                      mode={mode}
                      handleShowPopup={handleShowPopup}
          ></PortafolioServicesList>
        )}
      </div>
    </div>
  );
};

export default TablePortafolioServices;
